import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const AustinIcon = ()=>/*#__PURE__*/ _jsxs("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M16.687 17.2112H15.3911V18.4761H16.687V17.2112Z",
                fill: "#C25531"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16.687 15.5764H15.3911V16.8706H16.687V15.5764Z",
                fill: "#C25531"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16.687 13.9419H15.3911V15.2364H16.687V13.9419Z",
                fill: "#C25531"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16.687 12.3071H15.3911V13.6013H16.687V12.3071Z",
                fill: "#C25531"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16.687 10.6726H15.3911V11.9668H16.687V10.6726Z",
                fill: "#C25531"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16.687 9.03784H15.3911V10.332H16.687V9.03784Z",
                fill: "#C25531"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16.687 7.40332H15.3911V8.69749H16.687V7.40332Z",
                fill: "#C25531"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11.7775 4.13452H10.4819V18.4762H11.7775V4.13452Z",
                fill: "#C25531"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11.7775 2.5H10.4819V3.79416H11.7775V2.5Z",
                fill: "#C25531"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M13.4137 5.76904H12.1182V18.4762H13.4137V5.76904Z",
                fill: "#C25531"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M13.4137 4.13452H12.1182V5.42869H13.4137V4.13452Z",
                fill: "#C25531"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15.0505 7.40332H13.7549V18.4759H15.0505V7.40332Z",
                fill: "#C25531"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15.0505 5.76904H13.7549V7.06321H15.0505V5.76904Z",
                fill: "#C25531"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5.29593 17.2112H4V18.4761H5.29593V17.2112Z",
                fill: "#C25531"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5.29593 15.5764H4V16.8706H5.29593V15.5764Z",
                fill: "#C25531"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5.29593 13.9419H4V15.2364H5.29593V13.9419Z",
                fill: "#C25531"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5.29593 12.3071H4V13.6013H5.29593V12.3071Z",
                fill: "#C25531"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5.29593 10.6726H4V11.9668H5.29593V10.6726Z",
                fill: "#C25531"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5.29593 9.03784H4V10.332H5.29593V9.03784Z",
                fill: "#C25531"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5.29593 7.40332H4V8.69749H5.29593V7.40332Z",
                fill: "#C25531"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10.2048 4.13452H8.90918V18.4762H10.2048V4.13452Z",
                fill: "#C25531"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10.2048 2.5H8.90918V3.79416H10.2048V2.5Z",
                fill: "#C25531"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8.56854 5.76904H7.27295V18.4762H8.56854V5.76904Z",
                fill: "#C25531"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8.56854 4.13452H7.27295V5.42869H8.56854V4.13452Z",
                fill: "#C25531"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6.93231 7.40332H5.63672V18.4759H6.93231V7.40332Z",
                fill: "#C25531"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6.93231 5.76904H5.63672V7.06321H6.93231V5.76904Z",
                fill: "#C25531"
            })
        ]
    });
